// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__j53hq","body":"dashboard_body__jbsRi","admin":"dashboard_admin__FM4e9","manager":"dashboard_manager__r9urx","loadSpin":"dashboard_loadSpin__8gI3B"};